module.exports = __webpack_public_path__ + "img/IMG_2614_T_L_BlackMatted.5b079128.jpg";